module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-users"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v(" Dashboard"), (_vm.org().shortName) ? _c('small', {
    staticClass: "text-info pull-right hidden-sm-and-down"
  }, [_vm._v(_vm._s(_vm.org().name))]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "bg-bordered"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center",
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('request-action', {
    attrs: {
      "button-size": "small",
      "type": "RTA",
      "row-data": {},
      "plain": "",
      "round": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('request-action', {
    attrs: {
      "button-size": "small",
      "type": "RTS",
      "row-data": {},
      "plain": "",
      "round": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('request-action', {
    attrs: {
      "button-size": "small",
      "type": "RTU",
      "row-data": {},
      "plain": "",
      "round": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('request-action', {
    attrs: {
      "button-size": "small",
      "type": "RTB",
      "row-data": {},
      "plain": "",
      "round": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('ticket-action', {
    attrs: {
      "button-size": "small",
      "row-data": {},
      "plain": "",
      "round": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('hr'), _vm._v(" "), _c('op-stats', {
    attrs: {
      "show-only-requests": "",
      "no-background": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Site Summary")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "middle",
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('sites-chart', {
    attrs: {
      "show-legend": false
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "align": "left"
    }
  }, [_c('sites-stats-table')], 1)], 1), _vm._v(" "), (_vm.getStats().tickets > 0) ? _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Operations")]), _vm._v(" "), _c('op-stats', {
    attrs: {
      "show-requests": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Requests")]), _vm._v(" "), _c('requests-report', {
    attrs: {
      "summary": false
    }
  }), _vm._v(" "), _c('files-request-table'), _vm._v(" "), _c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Requests Calendar")]), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "requests"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48079374"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TelcoView.vue
// module id = 1458
// module chunks = 0